import { ForgetPassword } from 'api';

export const forgetPasswordFetcher = email => {
  const frontendUrl = `${window.location.protocol}//${window.location.host}/update-password`;
  return ForgetPassword.post({ email, frontendUrl });
};
